import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import expandedLayoutProps from '../Box/expandedLayoutProps';
var Flex = styled('div').withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Flex",
  componentId: "sc-15srg32-0"
})(["display:flex;", ""], expandedLayoutProps);
/** @component */

export default Flex;